import React, {useEffect, useMemo, useState} from 'react';
import API from "../../../utils/API";
import {API_ENDPOINTS} from "../../../apiConfig";
import AdminDataView from "../../../components/AdminDataView";
import Forms from "../../../components/Forms";
import EditIconButton from "../../../components/Forms/EditIconButton";
import DeleteIconButton from "../../../components/Forms/DeleteIconButton";
import {useModal} from "../../../contexts/ModalContext";
import PartVariantModal from "../../../components/PartVariantModal";

const PartVariants = () => {
    const [masters, setMasters] = useState([]);
    const [variants, setVariants] = useState([]);
    const [selectedMaster, setSelectedMaster] = useState(null);
    const [filter, setFilter] = useState('');
    const {openModal, confirm} = useModal();

    const load = async () => {
        const [masterRes, skuRes] = await Promise.all([
            API.get(API_ENDPOINTS.part.list),
            API.get(API_ENDPOINTS.partSku.list)
        ]);
        setMasters(masterRes.data || []);
        setVariants(skuRes.data || []);
    };

    useEffect(() => {
        load();
    }, []);

    const masterOptions = useMemo(() => (masters || []).map((m) => ({value: m._id, label: `${m.name} (${m.code})`})), [masters]);
    const openNew = () => openModal(PartVariantModal, {onSaved: load, masterPartId: selectedMaster?.value || null}, {title: 'Nová varianta'});
    const openEdit = (variant) => openModal(PartVariantModal, {variant, onSaved: load}, {title: 'Upravit variantu'});
    const askDelete = async (variant) => {
        const ok = await confirm(`Smazat variantu ${variant.name}?`);
        if (!ok) return;
        await API.delete(API_ENDPOINTS.partSku.delete(variant._id));
        await load();
    };

    const rows = (variants || []).filter((row) => {
        if (selectedMaster?.value && String(row?.part?._id || row?.part) !== String(selectedMaster.value)) return false;
        const q = filter.toLowerCase();
        if (!q) return true;
        return [row.name, row.sku, row?.part?.name, row?.part?.code].filter(Boolean).some((v) => String(v).toLowerCase().includes(q));
    });

    const columns = [
        {key: 'name', name: 'Název', renderCell: ({row}) => row.name, minWidth: 240},
        {key: 'sku', name: 'SKU', renderCell: ({row}) => row.sku, minWidth: 140},
        {key: 'master', name: 'Master', renderCell: ({row}) => `${row?.part?.name || '-'} (${row?.part?.code || '-'})`, minWidth: 220},
        {key: 'stockQuantity', name: 'Sklad', minWidth: 90},
        {key: 'storagePlace', name: 'Umístění', minWidth: 120},
        {key: 'attributes', name: 'Atributy', renderCell: ({row}) => Object.entries(row.attributes || {}).map(([k, v]) => `${k}: ${String(v)}`).join(', ')},
        {
            key: 'actions',
            name: 'Akce',
            width: 100,
            renderCell: ({row}) => (
                <div className="flex items-center justify-end h-full w-full">
                    <EditIconButton title="Upravit" onClick={() => openEdit(row)}/>
                    <DeleteIconButton title="Smazat" onClick={() => askDelete(row)}/>
                </div>
            )
        }
    ].map((c) => ({...c, resizable: true}));

    return (
        <div>
            <div className="grid grid-cols-4 gap-4 items-end mb-4">
                <Forms.Button label="Přidat variantu" onClick={openNew}/>
                <Forms.Select label="Master filtr" value={selectedMaster} options={masterOptions} onChange={setSelectedMaster}/>
                <Forms.Text label="Text filtr" value={filter} onChange={setFilter}/>
            </div>
            <AdminDataView section="part-variants" rows={rows} columns={columns}/>
        </div>
    );
};

export default PartVariants;
